import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;
export const fetchPaymentOptions = createAsyncThunk(
  "payment/fetchPaymentOptions",
  async (lang, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userTools"));

      const response = await axios.get(`${BASE_URL}/payment-options`, {
        headers: {
          Authorization: `Bearer ${token?.token}`,
          "Accept-Language": lang || "en",
        },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch payment options"
      );
    }
  }
);
